import { Preferences } from '@capacitor/preferences'

function camelToSnake(camelCaseKey: string): string {
  return camelCaseKey.replace(/[A-Z]/g, (match) => `_${match.toLowerCase()}`)
}

function removeLegacyValue(key: string) {
  localStorage.removeItem(camelToSnake(key))
  localStorage.removeItem(key)
}

function getLegacyValue<T>(key: string) {
  const legacyValue = localStorage.getItem(camelToSnake(key)) || localStorage.getItem(key)
  try {
    return legacyValue ? (JSON.parse(legacyValue) as T) : null
  } catch {
    return legacyValue
  }
}

async function getValue<T>(key: string): Promise<T | null> {
  const legacyValue = getLegacyValue(key)
  if (legacyValue) {
    await setValue(key, legacyValue)
    removeLegacyValue(key)
    return legacyValue as T
  }

  const { value } = await Preferences.get({ key })
  try {
    return value ? (JSON.parse(value) as T) : null
  } catch {
    await removeValue(key)
    return null
  }
}

async function setValue<T>(key: string, value: T) {
  removeLegacyValue(key)
  await Preferences.set({ key, value: JSON.stringify(value) })
}

async function removeValue(key: string) {
  await Preferences.remove({ key })
}

export default { getValue, setValue, removeValue }
